import { getBuildinfoTsup, getBuildinfoVite } from "@/share";
import { getAnybuildConfig, tsupModule } from "./loadModule";
import { merge } from "lodash-es";
import type { Options } from "tsup";
import { error } from "@/util";

const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]'
const isString = (obj) => Object.prototype.toString.call(obj) === '[object String]'

export async function buildByTsup() {
    const buildinfo = getBuildinfoTsup()
    const _config = getAnybuildConfig()?.config ?? {}

    const isDev = buildinfo.watch

    const genDTS = !isDev
    if (genDTS) {
        try {
            await import("typescript")
        } catch (err) {
            error(`未安装包：typescript`, "exit")
        }
    }

    if (_config.overide) {
        // 只使用配置文件的配置
        tsupModule.build(_config)
        return
    }
    const commonOptions: Options = {
        // @ts-ignore
        entry: (Array.isArray(buildinfo.entry) || isObject(buildinfo.entry)) ? buildinfo.entry :
            isString(buildinfo.entry) ? buildinfo.name ? {
                [buildinfo.name]: buildinfo.entry
            } : [buildinfo.entry] : buildinfo.entry,
        format: "esm",
        dts: genDTS,
        outDir: buildinfo.outDir,
        splitting: !isDev,
        sourcemap: true,
        watch: isDev,
        clean: true,
        define: {
            __DEV__: `${isDev}`,
        },
        minify: !isDev,
        config: false
    }
    if (buildinfo.mode === "cli") {
        tsupModule.build(merge(commonOptions, { banner: { js: "#!/usr/bin/env node" } }, _config))
    }
    if (buildinfo.mode === "lib") {
        tsupModule.build(merge(commonOptions, {}, _config))
    }
}